import React, { Component } from 'react'
import EscrowMyEther from '../build/contracts/EscrowMyEther.json'
import getWeb3 from './utils/getWeb3'
import NavLink from './NavLink'

import Web3 from 'web3'
import './index.css'

import {Link} from 'react-router'
import { IndexLink } from 'react-router'

import Home from './Home'



/*<li className="main-li"><NavLink to="/help">Help</NavLink></li>*/



class App extends Component {
	constructor(props){
		super(props)
		window.addEventListener('load', function() {
		var ETH_CLIENT
		
		if (typeof web3 !== 'undefined')
			{
				// eslint-disable-next-line no-undef
				ETH_CLIENT = new Web3(web3.currentProvider)
				
			}
		else
			{
				ETH_CLIENT = new Web3(new Web3.providers.HttpProvider("http://localhost:8545"));
				
			}
		
		var myetherescrowABI = [{"constant":false,"inputs":[{"name":"fee","type":"uint256"}],"name":"setEscrowFee","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"inputAddress","type":"address"},{"name":"switcher","type":"uint256"},{"name":"startID","type":"uint256"}],"name":"escrowSellerHistory","outputs":[{"name":"","type":"address[]"},{"name":"","type":"address[]"},{"name":"","type":"uint256[]"},{"name":"","type":"bytes32[]"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"},{"name":"","type":"uint256"}],"name":"sellerDatabase","outputs":[{"name":"buyer","type":"address"},{"name":"buyer_nounce","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"}],"name":"escrowFee","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"fromAddress","type":"address"}],"name":"CheckBalance","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"switcher","type":"uint256"},{"name":"ID","type":"uint256"}],"name":"EscrowEscalation","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"WithdrawFunds","outputs":[],"payable":true,"stateMutability":"payable","type":"function"},{"constant":true,"inputs":[{"name":"inputAddress","type":"address"},{"name":"switcher","type":"uint256"},{"name":"ID","type":"uint256"}],"name":"getSpecificTransaction","outputs":[{"name":"","type":"address"},{"name":"","type":"address"},{"name":"","type":"address"},{"name":"","type":"uint256"},{"name":"","type":"bytes32"},{"name":"","type":"uint256"},{"name":"","type":"bytes32"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"escrowAddress","type":"address"}],"name":"getEscrowFee","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"buyerAddress","type":"address"},{"name":"nounce","type":"uint256"}],"name":"checkStatus","outputs":[{"name":"","type":"bytes32"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"ID","type":"uint256"}],"name":"sellerRefund","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"ID","type":"uint256"},{"name":"Decision","type":"uint256"}],"name":"escrowDecision","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"},{"name":"","type":"uint256"}],"name":"buyerDatabase","outputs":[{"name":"buyer","type":"address"},{"name":"seller","type":"address"},{"name":"escrow_agent","type":"address"},{"name":"escrow_fee","type":"uint256"},{"name":"amount","type":"uint256"},{"name":"escrow_intervention","type":"bool"},{"name":"release_approval","type":"bool"},{"name":"refund_approval","type":"bool"},{"name":"notes","type":"bytes32"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"inputAddress","type":"address"},{"name":"switcher","type":"uint256"}],"name":"getNumTransactions","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"buyerAddress","type":"address"},{"name":"startID","type":"uint256"}],"name":"buyerHistory","outputs":[{"name":"","type":"address[]"},{"name":"","type":"address[]"},{"name":"","type":"uint256[]"},{"name":"","type":"bytes32[]"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"ID","type":"uint256"}],"name":"buyerFundRelease","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"sellerAddress","type":"address"},{"name":"escrowAddress","type":"address"},{"name":"notes","type":"bytes32"}],"name":"newEscrow","outputs":[{"name":"","type":"bool"}],"payable":true,"stateMutability":"payable","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"},{"name":"","type":"uint256"}],"name":"escrowDatabase","outputs":[{"name":"buyer","type":"address"},{"name":"buyer_nounce","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"}],"name":"Funds","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"payable":true,"stateMutability":"payable","type":"fallback"}]
		var myetherescrowAddress = '0xe509a834bf9ee3c27af895609e5cdd2f455c4854'
		var EscrowMyEtherEntityDB_ABI = [{"constant":false,"inputs":[{"name":"_name","type":"string"},{"name":"_info","type":"string"}],"name":"registerSeller","outputs":[],"payable":false,"type":"function"},{"constant":true,"inputs":[{"name":"escrowAddress","type":"address"}],"name":"getEscrowFullInfo","outputs":[{"name":"","type":"string"},{"name":"","type":"string"}],"payable":false,"type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"}],"name":"buyerList","outputs":[{"name":"name","type":"string"},{"name":"info","type":"string"}],"payable":false,"type":"function"},{"constant":true,"inputs":[{"name":"sellerAddress","type":"address"}],"name":"getSellerFullInfo","outputs":[{"name":"","type":"string"},{"name":"","type":"string"}],"payable":false,"type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"name":"","type":"address"}],"payable":false,"type":"function"},{"constant":true,"inputs":[{"name":"buyerAddress","type":"address"}],"name":"getBuyerFullInfo","outputs":[{"name":"","type":"string"},{"name":"","type":"string"}],"payable":false,"type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"}],"name":"sellerList","outputs":[{"name":"name","type":"string"},{"name":"info","type":"string"}],"payable":false,"type":"function"},{"constant":false,"inputs":[{"name":"_name","type":"string"},{"name":"_info","type":"string"}],"name":"registerBuyer","outputs":[],"payable":false,"type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"}],"name":"escrowList","outputs":[{"name":"name","type":"string"},{"name":"info","type":"string"}],"payable":false,"type":"function"},{"constant":false,"inputs":[{"name":"_name","type":"string"},{"name":"_info","type":"string"}],"name":"registerEscrow","outputs":[],"payable":false,"type":"function"},{"inputs":[],"payable":false,"type":"constructor"},{"payable":true,"type":"fallback"}]
		var EscrowMyEtherEntityDB_address = '0xb621c26281a11deb1e5bd37dbbbf6224bb67b09b'

		this.state = {

		
		
		//window.web3 = new Web3(web3.currentProvider)
		
		//var ETH_CLIENT = new Web3(new Web3.providers.HttpProvider("http://localhost:8545"))
		
		mee: ETH_CLIENT.eth.contract(myetherescrowABI).at(myetherescrowAddress),

		
		entitydb: ETH_CLIENT.eth.contract(EscrowMyEtherEntityDB_ABI).at(EscrowMyEtherEntityDB_address),

		accounts: ETH_CLIENT.eth.accounts,
		
		errorMsg: ""
		}

		
	})
	

	}


  render() {
	  var error = ""
	  var mainmenu = ""
	if (typeof web3 == 'undefined')
		{
			error = (
				<div className="info-bar">
				<p className="center">No connection with Ethereum node. Double check if node is active or view our <a href="#readme"><font className="linkfont2">Get Started guide</font></a>.</p>
				</div>
			)

			mainmenu = (
			<div className="main-ul">
			<ul>
			<li className="main-li"><IndexLink to="/">Home</IndexLink></li>
			<li className="disabled-li"><IndexLink to="/">Buyer</IndexLink></li>
			<li className="disabled-li"><IndexLink to="/">Seller</IndexLink></li>
			<li className="disabled-li"><IndexLink to="/">Escrow Agent</IndexLink></li>
			<li className="main-li"><a href="http://escrowmyether.com/#readme">Get Started</a></li>
			</ul>
			</div>
		)
		}
	else
		{
			error = (
				<div className="info-bar-green">
				<p className="center">Connection established with Ethereum node. Double check you are connected to Mainnet.</p>
				</div>
			)

			mainmenu = (
				<div className="main-ul">
				<ul>
	
				<li className="main-li"><IndexLink to="/" activeClassName="active">Home</IndexLink></li>
				<li className="main-li"><NavLink to="/buyer">Buyer</NavLink></li>
				<li className="main-li"><NavLink to="/seller">Seller </NavLink></li>
				<li className="main-li"><NavLink to="/escrow">Escrow Agent</NavLink></li>
				<li className="main-li"><a href="http://escrowmyether.com/#readme">Get Started</a></li>
				
				</ul>
				</div>
			)
		}


    return( 
		<div>
		
		<div className="navigation">
		<div className="leftlogo">
			<h2><IndexLink to="/">EscrowMyEther</IndexLink></h2></div> 
		
		</div>
		{mainmenu}

		{error}

		
    
    {this.props.children || <Home/>}
    
	</div>

	)
	
  }
}


export default App;



// WEBPACK FOOTER //
// ./src/App.js